/**
 * Feature 11 — Download Profile PDF button.
 *
 * Streams the PDF from /api/vendor/profile/pdf/ as a blob and triggers
 * a browser download.  Includes a spinner per spec §1140-1142.
 */
import { useState } from 'react';
import api from '../services/api';


export default function DownloadProfilePdfButton() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onClick = async () => {
    setBusy(true);
    setError(null);
    try {
      const response = await api.get('/vendor/profile/pdf/', {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      // Pull suggested filename from Content-Disposition.
      const disp: string = response.headers['content-disposition'] || '';
      const match = disp.match(/filename="?([^";]+)"?/);
      const filename = match ? match[1] : 'GuardGrade-Profile.pdf';
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {
      setError('Could not generate PDF. Please try again later.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={onClick}
        disabled={busy}
        className="rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 hover:bg-brand-600"
      >
        {busy ? 'Generating your profile PDF…' : 'Download profile PDF'}
      </button>
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
